module.exports = __webpack_public_path__ + "static/media/pencil.6fafa905.svg";